import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useCreateDeclaracionJuradaCeseActividadParcial = () => {
  const [loadingCreateDeclaracionJuradaCeseActividadParcial, setLoadingCreateSolicitudPagoDirecto] = useState(false);
  const [successCreateDeclaracionJuradaCeseActividadParcial, setSuccessCreateSolicitudPagoDirecto] = useState(false);
  const [errorCreateDeclaracionJuradaCeseActividadParcial, setErrorCreateSolicitudPagoDirecto] = useState(null);
  const [dataCreateDeclaracionJuradaCeseActividadParcial, setDataSolicitudPagoDirecto] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  )



  //CREATE
  const createDeclaracionJuradaCeseActividadParcial = async (userId:string , data: any ,_cb?:(data:any)=>void) => {
    setLoadingCreateSolicitudPagoDirecto(true);
    setSuccessCreateSolicitudPagoDirecto(false);
    setErrorCreateSolicitudPagoDirecto(null);

    apiRecord.newSolicitudDeclaracionJuradaParcial(userId, data).then((res: any) => {
      setLoadingCreateSolicitudPagoDirecto(false);
      setSuccessCreateSolicitudPagoDirecto(true);
      setDataSolicitudPagoDirecto(res.data);
      if (typeof _cb === "function") {
        _cb(res.data);
      }

    }).catch((err:any) => {
      console.log(err)
      setLoadingCreateSolicitudPagoDirecto(false);
      setErrorCreateSolicitudPagoDirecto(err.response.data)
    })
  }




  return {
    createDeclaracionJuradaCeseActividadParcial,
    loadingCreateDeclaracionJuradaCeseActividadParcial,
    successCreateDeclaracionJuradaCeseActividadParcial,
    errorCreateDeclaracionJuradaCeseActividadParcial,
    dataCreateDeclaracionJuradaCeseActividadParcial
  }

}

export default useCreateDeclaracionJuradaCeseActividadParcial;
